/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';
import StarStarredIcon from '@atlaskit/icon/core/star-starred';

export const StarredHeader = ({ label }: { label: string }): JSX.Element => (
	<div css={contentWrapperStyles}>
		<StarStarredIcon color="currentColor" label={label} />
	</div>
);

const contentWrapperStyles = css({
	display: 'flex',
	justifyContent: 'center',
});
